import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ChartModule } from 'primeng/primeng';

import { DashboardService } from './../services/dashboard.service';
import { IViewFoodTypeCountsModel, IViewRefusalCountSinceLastConsumptionModel } from './../interfaces/';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
	
	isAuthenticated: boolean = false;
  groupId: number = 0;
  foodTypeData: any;
  foodTypeChartData: any;
  refusalData: IViewRefusalCountSinceLastConsumptionModel[] = [];

  constructor(private router: Router, private _dashboardService: DashboardService) { }

  ngOnInit() {
    if(sessionStorage.getItem("token")){
          let obj = JSON.parse(sessionStorage.getItem("token"));
          if(obj && obj.Token != ""){
            this.isAuthenticated = true;
          }
        }
      else {
        this.router.navigate(['/login']);
      }

      if(sessionStorage.getItem("groupId")){
        let group = JSON.parse(sessionStorage.getItem("groupId"));
        if(group && group.GroupId != 0){
            this.groupId = group.GroupId;
        }
      }

      let startDate = new Date();
      let endDate = new Date();

      startDate.setDate(startDate.getDate()-31);

      let input = { groupId: this.groupId, startDate: startDate, endDate: endDate };

      this._dashboardService.getFoodTypeCountsByRange(input)
        .subscribe(
          resp => {
            this.loadLineChartData(resp);
          });

      this._dashboardService.getRefusalSinceLastConsumptionCount(input)
      .subscribe(
        resp => {
          this.refusalData = resp;
        });
  }

  loadLineChartData(foodTypeData: IViewFoodTypeCountsModel[]){
    let dataset = [];
    let labels = [];
    foodTypeData.forEach(data => {
      let newDate = new Date(data.WeekDate);
      let dateStringLabel = newDate.getDate().toString() +"/"+ newDate.getMonth().toString() +"/"+ newDate.getFullYear().toString();
      if(!labels.includes(dateStringLabel)){        
        labels.push(dateStringLabel);
        
      }
      let temp = { label: data.TypeName +"-" + data.SizeName, data: []};
      let exists = dataset.find(d => { return d.label == temp.label });
      if(!exists){
        dataset.push(temp);
      }
    });
    dataset.forEach(d => {
      foodTypeData.forEach(type => {
        if((type.TypeName +"-" + type.SizeName) == d.label){
          d.data.push(type.Count);
        }
        else {
          d.data.push(0);
        }
      })
    })
    this.foodTypeChartData = {
            labels: labels,
            datasets: dataset
            // datasets: [
            //     {
            //         label: 'First Dataset',
            //         data: [65, 59, 80, 81, 56, 55, 40],
            //         fill: false,
            //         borderColor: '#4bc0c0'
            //     },
            //     {
            //         label: 'Second Dataset',
            //         data: [28, 48, 40, 19, 86, 27, 90],
            //         fill: false,
            //         borderColor: '#565656'
            //     }
            // ]
        }
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts